import React from 'react';
import { Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import SpellcheckRoundedIcon from '@mui/icons-material/SpellcheckRounded';
import { formatInt } from '../../utils/format';
import WidgetShell from './WidgetShell';

function WordcraftWidget({ stats }) {
  const items = [
    { label: 'Words Submitted', value: formatInt(stats?.scoring?.lifetimeSubmittedWords) },
    { label: 'Submits Used', value: formatInt(stats?.scoring?.lifetimeSubmitsUsed) },
    { label: 'Discards Used', value: formatInt(stats?.scoring?.lifetimeDiscardsUsed) },
    { label: 'Tiles Discarded', value: formatInt(stats?.scoring?.lifetimeDiscardedTiles) },
  ];

  return (
    <WidgetShell
      icon={<SpellcheckRoundedIcon color="primary" fontSize="small" />}
      title="Wordcraft"
    >
      <Stack spacing={1}>
        {items.map((item) => (
          <Stack
            key={item.label}
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              px: 1.2,
              py: 0.9,
              borderRadius: 2,
              backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.04),
            }}
          >
            <Typography variant="body2" color="text.secondary">
              {item.label}
            </Typography>
            <Typography sx={{ fontWeight: 800 }}>{item.value}</Typography>
          </Stack>
        ))}
      </Stack>
    </WidgetShell>
  );
}

export default WordcraftWidget;
